export default "__VITE_ASSET__f4d2c4b2__"